<template>
    <img v-if="id === 1 && disabled" src="@/assets/images/goods/1.disabled.svg" />
    <img v-else-if="id === 2 && disabled" src="@/assets/images/goods/2.disabled.svg" />
    <img v-else-if="id === 3 && disabled" src="@/assets/images/goods/3.disabled.svg" />
    <img v-else-if="id === 4 && disabled" src="@/assets/images/goods/4.disabled.svg" />
    <img v-else-if="id === 5 && disabled" src="@/assets/images/goods/5.disabled.svg" />
    <img v-else-if="id === 6 && disabled" src="@/assets/images/goods/6.disabled.svg" />
    <img v-else-if="id === 7 && disabled" src="@/assets/images/goods/7.disabled.svg" />

    <img v-else-if="id === 2" src="@/assets/images/goods/2.svg" />
    <img v-else-if="id === 1" src="@/assets/images/goods/1.svg" />
    <img v-else-if="id === 3" src="@/assets/images/goods/3.svg" />
    <img v-else-if="id === 4" src="@/assets/images/goods/4.svg" />
    <img v-else-if="id === 5" src="@/assets/images/goods/5.svg" />
    <img v-else-if="id === 6" src="@/assets/images/goods/6.svg" />
    <img v-else-if="id === 7" src="@/assets/images/goods/7.svg" />
</template>

<script>
    export default {
        props: {
            id: {
                type: Number,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            }
        }
    }
</script>
